module.exports = __webpack_public_path__ + "img/downloadImg_5_1.d5ed1f40.png";